import script from "./HighlightText.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightText.vue?vue&type=script&setup=true&lang=js"

import "./HighlightText.vue?vue&type=style&index=0&id=30b2910e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b2910e"]])

export default __exports__